import React from "react";
import DataGridTableAdapter from "./DataGridTableAdapter";
//import { Badge } from "react-bootstrap";
import DiffArrow from "./DiffArrow";

class LeaderBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: [] };
  }

  apiUrl = process.env.REACT_APP_BACKEND_HOST + `/api/getPlayers?leaderboard=${this.props.leaderboardId}`;

  refreshTable() {
    fetch(this.apiUrl)
      .then((response) => response.json())
      .then((players) =>
        this.setState({
          data: players.sort(function (a, b) { return parseInt(b.rating) - parseInt(a.rating) }),
        })
      ).catch(rejected => {
        console.log(rejected);
      });
  }

  componentDidMount() {
    this.refreshTable();
  }

  columns = [
    {
      title: "#",
      type: "numeric",
      sorting: false,
      render: (rowData, row) => {
        return <div> {rowData.tableData.id + 1}</div>
        //console.log(rowData.lookup);
      },
    },
    {
      field: 'discord_avatar',
      title: ' ',
      sorting: false,
      grouping: false,
      align: "right",
      render: rowData =>
        rowData.discord_avatar ?
          <img src={`https://cdn.discordapp.com/avatars/${rowData.discord_id}/${rowData.discord_avatar}.webp?size=1024`}
            alt="avatar"
            style={{ width: 25, borderRadius: '50%' }}
          /> :
          <img src={`https://cdn.discordapp.com/embed/avatars/0.png?size=1024`}
            alt="avatar"
            style={{ width: 25, borderRadius: '50%' }}
          />
    },
    {
      title: "Utente Discord", field: "discord_name", type: "numeric", align: "left",
      render: rowData => <a
        href={`discord://discordapp.com/users/${rowData.discord_id}/`}
        target="_blank"
        rel="noreferrer"
      >
        {rowData.discord_name}
      </a>
    },
    { title: "Utente AoE", field: "name" },
    { title: "Rating", field: "rating", type: "numeric", defaultSort: "desc" },
    {
      title: "",
      type: "numeric",
      sorting: false,
      render: (rowData) => {
        var diff = rowData.rating - rowData.previous_rating;
        return <DiffArrow diff={diff} />;
      },
    },
    { title: "Max Rating", field: "highest_rating", type: "numeric" },
    { title: "Partite", field: "games", type: "numeric" },
    { title: "Ultima Serie", field: "streak", type: "numeric" },
    { title: "Vinte", field: "wins", type: "numeric" },
    { title: "Perse", field: "losses", type: "numeric" },
    { title: "Disconnesse", field: "drops", type: "numeric" },
    {
      title: "Win%",
      type: "numeric",
      sorting: false,
      render: (rowData) => {
        var win_rate = Math.round(rowData.wins * 100 / (rowData.wins + rowData.losses));
        return win_rate + "%";
      },
    },
    {
      title: "Ultima partita", field: "last_match_time",
      render: (rowData) => {
        var myDate = new Date(rowData.last_match_time * 1000);
        return (<div>{myDate.toLocaleString()}</div>);
      },
    },
    // {
    //   title: "Ruolo",
    //   field: "role_name",
    //   sorting: false,
    //   render: (rowData) => {
    //     return (
    //       <Badge
    //         className="badge"
    //         bsPrefix={rowData.role_name.replace(/\s+/g, "")}
    //         variant="primary"
    //       >
    //         {rowData.role_name}
    //       </Badge>
    //     );
    //   },
    // },
  ];

  render() {
    return (
      <div className="LeaderBoard">
        <DataGridTableAdapter
          columns={this.columns}
          data={this.state.data}
          title=""
          onRefresh={() => this.refreshTable()}
        />
      </div>
    );
  }
}

export default LeaderBoard;
